import { PhoneAuthProvider, signInWithCredential } from "firebase/auth";
import toast from "react-hot-toast";
import { auth } from "./firebase";
import { CONSUMED_FE_URL } from "../../../config";

export const verifyOTP = async (otp, mode = "signup") => {
  const confirmationResultString = sessionStorage.getItem("otp");
  if (!confirmationResultString) {
    toast.error("No confirmation result found. Please request OTP again.");
    return;
  }
  const confirmationResult = JSON.parse(confirmationResultString);

  const credential = PhoneAuthProvider.credential(
    confirmationResult.verificationId,
    otp
  );
  try {
    const result = await signInWithCredential(auth, credential);
    const idToken = await result.user.getIdToken();

    return idToken;
  } catch (error) {
    toast.error("Invalid OTP. Please try again.");
    throw error;
  }
};
